var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regions"},[_c('h1',[_vm._v("Coach Tour Regions")]),_c('Regions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }